import { apiRequest } from './client'

export type LearningPricingMode = 'free' | 'paid' | 'mixed'
export type LearningStatus = 'draft' | 'published' | 'archived'

export interface LearningTutorial {
  id: number
  category_code: string
  title: string
  description: string
  cover_url: string
  pricing_mode: LearningPricingMode
  free_episode_count: number
  unlock_points: number
  episode_unlock_points: number
  status: LearningStatus
  sort_order: number
  episode_count: number
  unlocked?: boolean
  full_unlocked?: boolean
  created_at: string
  updated_at: string
}

export interface LearningEpisode {
  id: number
  tutorial_id: number
  title: string
  description: string
  video_url?: string
  duration_seconds: number
  sort_order: number
  unlock_points: number
  accessible: boolean
  unlocked: boolean
  requires_login: boolean
  requires_unlock: boolean
  created_at: string
  updated_at: string
}

export interface LearningTutorialList {
  total: number
  items: LearningTutorial[]
}

export interface LearningEpisodeList {
  total: number
  items: LearningEpisode[]
}

export interface LearningUnlockResult {
  entitlement_id: number
  point_tx_id: number
  balance_after: number
  already_owned: boolean
}

export const learningApi = {
  listTutorials: (params?: { limit?: number; offset?: number; category_code?: string; q?: string }) =>
    apiRequest<LearningTutorialList>('/api/v1/learning/tutorials', { query: params, auth: false }),

  getTutorial: (id: number) =>
    apiRequest<LearningTutorial>(`/api/v1/learning/tutorials/${id}`, { auth: false }),

  listEpisodes: (tutorialId: number, params?: { limit?: number; offset?: number }) =>
    apiRequest<LearningEpisodeList>(`/api/v1/learning/tutorials/${tutorialId}/episodes`, {
      auth: false,
      query: params,
    }),

  playEpisode: (episodeId: number) =>
    apiRequest<LearningEpisode>(`/api/v1/learning/episodes/${episodeId}/play`, { auth: false }),

  unlockTutorial: (tutorialId: number) =>
    apiRequest<LearningUnlockResult>(`/api/v1/learning/tutorials/${tutorialId}/unlock`, {
      method: 'POST',
    }),

  unlockEpisode: (episodeId: number) =>
    apiRequest<LearningUnlockResult>(`/api/v1/learning/episodes/${episodeId}/unlock`, {
      method: 'POST',
    }),
}
